import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_star",
  "use": "icon-project_star-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-project_star\"><path d=\"M8 13l-4.702 2.472.898-5.236L.392 6.528l5.257-.764L8 1l2.351 4.764 5.257.764-3.804 3.708.898 5.236z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol